import _jsx from '@babel/runtime/helpers/jsx';
import 'react';
import 'prop-types';
import cn from 'classnames';
var _div, _div2, _div3, _Line, _Line2, _Line3, _Line4, _Line5;
const namespace = 'ui-pdp-placeholder';
const SECOND_TITLE_LINE_REQUIRED_HEIGHT = 127;
const SECOND_SUBTITLE_LINE_REQUIRED_HEIGHT = 92;
const THIRD_SUBTITLE_LINE_REQUIRED_HEIGHT = 146;
const Placeholder = _ref => {
  let {
    children,
    className = ''
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: cn(namespace, className)
  }, void 0, children);
};
const Line = _ref2 => {
  let {
    className = '',
    width = '100%',
    height
  } = _ref2;
  return /*#__PURE__*/_jsx("div", {
    className: cn(`${namespace}__line`, className),
    style: {
      width,
      height
    }
  });
};
const Skeleton = _ref3 => {
  let {
    className = ''
  } = _ref3;
  return /*#__PURE__*/_jsx(Placeholder, {
    className: cn(namespace, `${namespace}--media`, className)
  }, void 0, _div || (_div = /*#__PURE__*/_jsx("div", {
    className: `${namespace}__header`
  }, void 0, /*#__PURE__*/_jsx("span", {
    className: `${namespace}__avatar`
  }))), _div2 || (_div2 = /*#__PURE__*/_jsx("div", {
    className: `${namespace}__body`
  }, void 0, /*#__PURE__*/_jsx(Line, {
    height: "12px",
    width: "65%"
  }), /*#__PURE__*/_jsx(Line, {
    height: "12px",
    width: "52%"
  }))));
};
const CardTooltipSkeleton = _ref4 => {
  let {
    className = '',
    hasIcon = false,
    hasProgressBar = false,
    height = 0
  } = _ref4;
  return /*#__PURE__*/_jsx(Placeholder, {
    className: cn(namespace, `${namespace}--media`, className)
  }, void 0, hasIcon && (_div3 || (_div3 = /*#__PURE__*/_jsx("div", {
    className: `${namespace}__header`
  }, void 0, /*#__PURE__*/_jsx("span", {
    className: `${namespace}__avatar`
  })))), /*#__PURE__*/_jsx("div", {
    className: `${namespace}__body`
  }, void 0, /*#__PURE__*/_jsx("div", {}, void 0, _Line || (_Line = /*#__PURE__*/_jsx(Line, {
    className: `${namespace}__line__title`,
    height: "18px"
  })), height >= SECOND_TITLE_LINE_REQUIRED_HEIGHT && (_Line2 || (_Line2 = /*#__PURE__*/_jsx(Line, {
    className: `${namespace}__line__title`,
    height: "18px"
  })))), hasProgressBar && (_Line3 || (_Line3 = /*#__PURE__*/_jsx(Line, {
    className: `${namespace}__line__progress-bar`,
    height: "6px"
  }))), /*#__PURE__*/_jsx(Line, {
    className: `${namespace}__line__subtitle`,
    height: height >= SECOND_SUBTITLE_LINE_REQUIRED_HEIGHT ? '16px' : '18px'
  }), height >= SECOND_SUBTITLE_LINE_REQUIRED_HEIGHT && (_Line4 || (_Line4 = /*#__PURE__*/_jsx(Line, {
    className: `${namespace}__line__subtitle`,
    height: "16px"
  }))), height >= THIRD_SUBTITLE_LINE_REQUIRED_HEIGHT && (_Line5 || (_Line5 = /*#__PURE__*/_jsx(Line, {
    className: `${namespace}__line__subtitle`,
    height: "16px"
  })))));
};
export { CardTooltipSkeleton, Line, Placeholder, Skeleton };
